<template>
    <el-button type="success" :size="size" :disabled="disabled" @click="doExamine"><i class="fa fa-shield"></i>&nbsp;{{disabled? '已审核' : '审核通过'}}</el-button>
</template>
<script>
    /**
     * 审核按钮
     * @author zjs
     * @time 2017-10-18
     * @param infoId 【description: ID,如12】
     * @param isdisabled 【description: 是否禁用,true,false】
     * @param route 【description: 路由】
     * @param style 【description: 类型 , 如 三包登记，三包理赔】
     */
    export default {
        name: 'LyButtonExamine',
        props: {
            infoId: {
                type: [String, Number],
                default: ''
            }, 
            disabled: {
                type: Boolean,
                default: false
            },
            route: {
                type: String,
                default: ''
            },
            size: {
                type: String,
                default: 'small'
            },
            // 作废完成后的回调函数
            callback: Function 
        },
        methods: {
            /**
             * 作废处理
             * @return {[type]} [description]
             */
            doExamine () {
                this.$confirm('审核通过后将不可修改！确认要审核通过？','审核提醒',{
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning',
                }).then(() => {
                    this.$api.create(this.route + '/' + this.infoId + '/review').then((rs) => {
                        // this.isdisabled = true
                        this.$message({
                            type: 'success',
                            message: '审核完成.'
                        })
                        // 调用回调函数
                        this.callback()
                    }).catch((msg) => {
                        this.$alert(msg,'审核提醒',{
                            confirmButtonText: '确定',
                            callback: action => {
                                this.$message({
                                    type: 'info',
                                    message: '本单审核操作失效'
                                })  
                            }
                        })
                    })
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消本单审核操作！'
                    })  
                })
            }
        }
    }
</script>